import React from 'react';
import { Link } from 'react-router-dom';

const EmptyOrderPage: React.FC = () => {
  return (
    <section className="flex items-start justify-center min-h-[70vh] bg-transparent">
      <div className="flex flex-col items-center w-full max-w-lg p-6 sm:p-8 text-center bg-white rounded-xl shadow-sm border border-gray-100">
        
        <div className="mb-4">
          <img
            src="https://www.shutterstock.com/image-vector/jewelry-shop-display-gold-necklaces-260nw-2491599809.jpg" 
            alt="Empty orders illustration showing jewelry"
            className="w-48 h-48 sm:w-64 sm:h-64 mx-auto object-contain"
          />
        </div>

        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3">
          You haven't placed any orders yet!
        </h2>

        <p className="text-sm sm:text-base text-gray-500 mb-8 max-w-sm">
          Your order section is empty. After placing an order, you can easily track it from here.
        </p>

        <Link 
          to="/" 
          className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3 text-base font-medium rounded-lg text-white bg-[#a5885c] hover:bg-[#8e7552] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#a5885c] transition duration-200 shadow-md hover:shadow-lg"
        >
          Continue Shopping
        </Link>
      </div>
    </section>
  );
};

export default EmptyOrderPage;